import { createContext, useContext } from "react";
import { Product } from "@/api/product-api";

export interface TactSuitCardContextValue {
  product: Product;
  sku?: string;
  theme?: "light" | "dark";
}

const TactSuitCardContext = createContext<TactSuitCardContextValue | null>(
  null,
);

export const useTactSuitCardContext = () => {
  const context = useContext(TactSuitCardContext);
  if (!context) {
    throw new Error(
      "TactSuitCard compound components cannot be rendered outside the TactSuitCard component",
    );
  }
  return context;
};

export const TactSuitCardProvider = TactSuitCardContext.Provider;
